/**
 * HUDStatCard — Tuile statistique cockpit (top-row sur les pages migrées).
 * Aligné sur le design system Cockpit (design-tokens.css + HudKpiTile).
 * API préservée : { icon, label, value, hint, accent, testid }
 */
const HUDStatCard = ({ icon: Icon, label, value, hint, accent = 'var(--c-gold)', testid }) => {
  return (
    <div
      className="hud-stat-card hud-card hud-card-glass relative group"
      data-testid={testid || 'hud-stat-card'}
      style={{ padding: 18, minHeight: 124 }}
    >
      {/* Halo accent gold (révélé au hover) */}
      <span
        aria-hidden
        className="pointer-events-none absolute -bottom-12 -right-12 w-40 h-40 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500"
        style={{ background: 'var(--c-gold-glow)', filter: 'blur(40px)' }}
      />

      <div className="relative z-[1] flex items-start justify-between gap-2 mb-3">
        {Icon && (
          <div
            className="w-9 h-9 rounded-xl flex items-center justify-center transition-colors"
            style={{
              background: 'var(--c-gold-soft)',
              border: '1px solid var(--c-border-accent)',
            }}
          >
            <Icon className="w-4 h-4" style={{ color: accent }} strokeWidth={1.75} />
          </div>
        )}
        <p className="hud-eyebrow mt-1.5">{label}</p>
      </div>

      <p
        className="hud-tabular relative font-semibold leading-none"
        style={{
          fontFamily: 'Outfit, sans-serif',
          color: 'var(--c-text)',
          fontSize: 'clamp(26px, 2.6vw, 32px)',
        }}
      >
        {value}
      </p>
      {hint && (
        <p
          className="relative mt-2 text-[11.5px]"
          style={{ color: 'var(--c-text-muted)' }}
        >
          {hint}
        </p>
      )}
    </div>
  );
};

export default HUDStatCard;
